module.exports = __webpack_public_path__ + "static/media/profile_unselected.d11d2396.svg";